import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Icon,
  Grid,
  GridItem,
  Image,
} from "@chakra-ui/react";

const CaseStudySection = ({
  title,
  subtitle,
  description,
  features,
  containerMaxW = "7xl",
}) => {
  return (
    <Box w="full" py={0} >
      <Container maxW={containerMaxW} px={0}>
        <VStack spacing={0} align="start">
          {/* Title and Description */}
          <VStack spacing={4} align="start" w="full">
            <Heading
              fontSize={{ base: "2xl", md: "3xl" }}
              fontWeight="bold"
              color="#000B8C"
              textAlign="start"
            >
              {title} <Text as="span" color="gray.800"> {subtitle}</Text>
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color="gray.600"
              lineHeight="1.4"
              textAlign="justify"
            >
              {description}
            </Text>
          </VStack>

          {/* Features Grid - 4 columns */}
          <Grid
            templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }}
            gap={6}
            w="full"
          >
            {features.map((feature, index) => (
              <GridItem key={feature.id || index}>
                <VStack
                  align="center"
                  spacing={4}
                  textAlign="center"
                  p={8}
                  h="full"
                >
                  <Image
                    src={feature.icon}
                    alt={feature.title}
                    // w={12}
                    // h={12}
                    className="feature-icon"
                    transition="all 0.3s ease"
                  />

                  <Text
                    fontWeight="bold"
                    color="gray.800"
                    fontSize="md"
                    lineHeight="1.4"
                  >
                    {feature.title}
                  </Text>
                </VStack>
              </GridItem>
            ))}
          </Grid>
        </VStack>
      </Container>
    </Box>
  );
};

export default CaseStudySection;